import React from 'react'

// styles
import { HeaderStyles } from './styles/styles.header'

// components
import Logo from './includes/Logo'
import Menu from './includes/Menu'
import RightSec from './includes/RightSec'

export default function Header() {
	return (
		<HeaderStyles>
			<div className="container">
				<div className="header com-pad-lr__lg d-flex flex-wrap align-items-center">
					{/* logo */}
					<Logo />

					{/* menu */}
					<Menu />

					{/* right */}
					<RightSec />
				</div>
			</div>
		</HeaderStyles>
	)
}
